import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@/components/ui/dialog';
import { Play, User, Share2 } from 'lucide-react';

export const ONBOARDING_STORAGE_KEY = 'dc_onboarding_seen';

interface WelcomeModalProps {
  open: boolean;
  onClose: () => void;
}

export function WelcomeModal({ open, onClose }: WelcomeModalProps) {
  // Pure controlled component — persistence is owned by the parent via onClose.
  return (
    <Dialog open={open} onOpenChange={(isOpen) => { if (!isOpen) onClose(); }}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Welcome to Dominion Mandate!</DialogTitle>
          <DialogDescription>
            Get started with these quick tips to make the most of your experience.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 py-2">
          <div className="flex items-start gap-3">
            <div className="flex-shrink-0 w-9 h-9 rounded-full bg-primary/10 flex items-center justify-center">
              <Play className="h-4 w-4 text-primary" aria-hidden="true" />
            </div>
            <div>
              <p className="font-medium text-sm">Watch a live stream</p>
              <p className="text-xs text-muted-foreground">
                Browse live and upcoming streams directly from your dashboard.
              </p>
            </div>
          </div>

          <div className="flex items-start gap-3">
            <div className="flex-shrink-0 w-9 h-9 rounded-full bg-primary/10 flex items-center justify-center">
              <User className="h-4 w-4 text-primary" aria-hidden="true" />
            </div>
            <div>
              <p className="font-medium text-sm">Complete your profile</p>
              <p className="text-xs text-muted-foreground">
                Add a photo and bio so others in the community can recognise you.
              </p>
            </div>
          </div>

          <div className="flex items-start gap-3">
            <div className="flex-shrink-0 w-9 h-9 rounded-full bg-primary/10 flex items-center justify-center">
              <Share2 className="h-4 w-4 text-primary" aria-hidden="true" />
            </div>
            <div>
              <p className="font-medium text-sm">Invite a friend</p>
              <p className="text-xs text-muted-foreground">
                Share the platform with your church community.
              </p>
            </div>
          </div>
        </div>

        <Button onClick={onClose} className="w-full mt-2">
          Get started
        </Button>
      </DialogContent>
    </Dialog>
  );
}
